export default __webpack_public_path__ + "static/media/billy.614f2f82.png";